/* eslint-disable no-plusplus */
const calculateSum = (
  numbers: string,
  length: number,
  weights: number[],
): number => {
  let sum = 0;
  for (let i = 0; i < length; i++) {
    const digit = parseInt(numbers.charAt(i), 10);
    sum += digit * weights[i];
  }
  return sum;
};

const calculateResult = (sum: number): number =>
  sum % 11 < 2 ? 0 : 11 - (sum % 11);

const createWeights = (length: number, initialWeight: number): number[] => {
  const weights = [];
  let weight = initialWeight;
  for (let i = 0; i < length; i++) {
    weights.push(weight);
    weight--;
    if (weight < 2) weight = 9;
  }
  return weights;
};

const checkDigit = (
  cnpj: string,
  length: number,
  initialWeight: number,
): boolean => {
  const numbers = cnpj.substring(0, length);
  const digit = parseInt(cnpj.charAt(length), 10);
  const weights = createWeights(length, initialWeight);
  const sum = calculateSum(numbers, length, weights);

  const result = calculateResult(sum);
  return result === digit;
};

const Checksum = (cnpj: string): boolean =>
  checkDigit(cnpj, cnpj.length - 2, 5) && checkDigit(cnpj, cnpj.length - 1, 6);

const validateCnpj = (cnpj?: string): boolean => {
  if (!cnpj) return false;

  const cnpjWithoutMask = cnpj.replace(/[^\d]+/g, "");
  if (cnpjWithoutMask.length !== 14) return false;

  return Checksum(cnpjWithoutMask);
};

export default validateCnpj;
